module.exports = __webpack_public_path__ + "01_long_brown.4eb0bb38.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_long_brown.png
// module id = KgNm
// module chunks = 0